import { ActionTree } from 'vuex'
import { ResponseArray, RootState } from '../types'
import State from './types'
import { Model, ModelFilter } from '../editor-model/types'
import { Api } from '@/api/Api'
const api = new Api()

export const actions: ActionTree<State, RootState> = {
  toggleProductModels({ commit }, isOpen) {
    commit('productModelsToggled', isOpen)
  },
  resetCategoriesOpen({ commit }) {
    commit('categoriesOpenReset')
  },
  findModel({ commit }, { filters }: { filters: ModelFilter[] }): any {
    commit('modelSearchResultsLoading')
    const url = '/modelFinder/FindModels'
    const payload = { CatalogOrModelNumber: '' }
    const obj = filters.map(filter => ({
      EntityName: filter.editorField.EntityProperty.EntityObject.EntityName,
      EntityPropertyName: filter.editorField.EntityProperty.EntityPropertyName,
      Value: filter.value,
      Blank: filter.blank,
      Negate: filter.negate,
    }))

    return api.fetch({
      url,
      payload,
      obj,
    })
      .then(response => {
        const modelSearchResults: ResponseArray<Model> = response

        response.List.forEach(model => {
          model.editing = false
          model.copying = false
          model.adding = false
        })

        commit('modelSearchResultsLoaded', { modelSearchResults })
        return modelSearchResults
      }).catch(() => {
        commit('modelSearchResultsError')
      })
  },
}
